/**
 * Detects if the current browser is running on Android or is Chrome (but NOT on iOS devices)
 * Used for optimistic Google Pay rendering
 * iOS devices use Apple Pay, so we exclude them even if using Chrome
 */
export const isAndroidOrChrome = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  
  // Check for iOS devices (iPhone, iPad, iPod)
  const isIOS = /iphone|ipad|ipod/i.test(userAgent);
  
  // If iOS, don't show optimistic Google Pay (they use Apple Pay)
  if (isIOS) {
    return false;
  }
  
  // Check for Android
  const isAndroid = /android/i.test(userAgent);
  
  // Check for Chrome (but not Edge, which also contains 'chrome' in user agent)
  const isChrome = /chrome/i.test(userAgent) && !/edg/i.test(userAgent);
  
  const result = isAndroid || isChrome;
  
  return result;
};

/**
 * Checks if Google Pay is potentially available based on browser capabilities
 */
export const couldGooglePayBeAvailable = (): boolean => {
  // Google Pay requires certain APIs to be available
  // This is a basic check - the actual availability is determined by Stripe
  return isAndroidOrChrome();
};

